/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Registration_UrlInputs */



/**
* | output |
* | --- |
* | "Registration URL" |
*
* @param {Tfield_Registration_UrlInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_registration_url = /** @type {((inputs?: Tfield_Registration_UrlInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Registration_UrlInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL d'inscription")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("URL de inscrição")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL di iscrizione")
	return /** @type {LocalizedString} */ ("Registration URL")
});